import React from 'react';
import { useSelector } from 'react-redux';

import Icon from './Icon';
import { getHelpLinePhoneNumbers } from 'modules/dealers/selectors';

const DealersPhone = () => {
  const phoneNumbers = useSelector(getHelpLinePhoneNumbers);

  return (
    <div className="flex flex-col items-center mt-4 kioskSharebox:mt-6 kiosk:mt-8">
      {phoneNumbers.map(({ dealerName, selfServicePhoneNumber: phone }) => (
        <div
          key={`${dealerName}_${phone.prefix}_${phone.local}`}
          className="inline-flex font-bold items-center flex-row flex-wrap justify-center"
        >
          {dealerName && <span>{dealerName}: </span>}
          {!dealerName && <Icon className="fb-icon--phone text-xl kiosk:text-2xl text-default" />}
          <span className="ml-4 font-bold">{`+${phone.prefix} ${phone.local}`}</span>
        </div>
      ))}
    </div>
  );
};

export default DealersPhone;
